import React from 'react';
import { ValueContainerProps } from 'react-select';
import classNames from 'classnames';

import { InputClassProps } from '../../input-class-name.util';
import { Option } from '../option.model';

export const ValueContainer = ({
  children,
  height,
}: ValueContainerProps<Option, true> & InputClassProps) => (
  <div
    className={classNames(
      'value-container flex items-center flex-wrap gap-2 flex-1 relative overflow-hidden',
      {
        'py-0 px-1 text-sm': height === 'sm',
        'py-2 px-3 text-base': height === 'md',
      }
    )}
  >
    {children}
  </div>
);
